import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { WfMdProcessStatusContainerModel } from "../../../../../../models";
import { BaseApiTemplateService, Core2Config } from "../../shared";

@Injectable({ providedIn: "root" })
export class WfMdProcessStatusService extends BaseApiTemplateService<WfMdProcessStatusContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.WF_PREFIX + "md/process-status";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.WF_PREFIX + "md/process-status";
    this.httpClient = http;
  }
}
